export enum MicrositeUiType {
  Microsite = "Microsite"
}
